import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { routes } from 'app/constants';
import BackButton from 'app/shared/navigation/BackButton';

export default function BackToPipelineOverviewButton({ pipelineId, pipelineName }) {
  const history = useHistory();
  const referrer = history.location.state?.referrer;

  const isFromAnalyticsFiles = referrer === routes.analyticsFiles;

  let to;
  let buttonText;

  if (isFromAnalyticsFiles) {
    to = routes.analyticsFiles;
    buttonText = 'Back to Analytics Files';
  } else {
    to = { pathname: routes.pipelineDetails, state: { pipelineId } };
    buttonText = `Back to ${pipelineName}`;
  }

  return <BackButton to={to}>{buttonText}</BackButton>;
}

BackToPipelineOverviewButton.propTypes = {
  pipelineId: PropTypes.string.isRequired,
  pipelineName: PropTypes.string.isRequired,
};
